import { Inject, Injectable } from '@angular/core'
import { GbNotificationService } from '@galabid/shared/utils/notification'
import { StripePaymentElement } from '@stripe/stripe-js'
import { EnvironmentModel } from 'apps/gb-dashboard/src/environments/environment.model'
import * as StripeActions from 'libs/gb-dashboard/shared/data-access-stripe/src/lib/+state/stripe.actions'
import { StripeFacade } from 'libs/gb-dashboard/shared/data-access-stripe/src/lib/+state/stripe.facade'
import { APP_CONFIG } from 'libs/shared/app-config/src/lib/gb-app-config'
import { GbBaseStripeService } from 'libs/shared/utils/services/src/lib/gb-stripe/gb-base-stripe.service'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbStripeService extends GbBaseStripeService {
  paymentElementSubject = new BehaviorSubject<StripePaymentElement | undefined>(undefined)
  paymentElement$ = this.paymentElementSubject.asObservable()

  paymentElementReadySubject = new BehaviorSubject<boolean>(false)
  paymentElementReady$ = this.paymentElementReadySubject.asObservable()

  constructor(
    @Inject(APP_CONFIG) protected override appConfig: EnvironmentModel,
    private stripeFacade: StripeFacade,
    gbNotificationService: GbNotificationService,
  ) {
    super(appConfig, gbNotificationService)
  }

  protected onPaymentSuccessHook(): void {
    this.stripeFacade.dispatch(StripeActions.handlePaymentCompletion())
  }

  clearPayment(): void {
    this.payment = null
  }

  resetStripeElements(): void {
    this.paymentElementSubject.next(undefined)
    this.paymentElementReadySubject.next(false)
  }
}
